import { graphql } from 'react-apollo';

import { compose } from 'recompose';

import connectToRouter from 'js/lib/connectToRouter';
import { getCmsLocaleString } from 'js/lib/language';

import type {
  UnifiedCareerAcademyPageContentFieldsFragment,
  UnifiedCareerAcademyPageContentQuery,
  UnifiedCareerAcademyPageContentQueryVariables,
} from 'bundles/unified-career-academy/__generated__/contentfulTypes';
import { unifiedCareerAcademyPageContentQuery } from 'bundles/unified-career-academy/queries/contentfulQueries';

export type PropsFromContentful = {
  pageContent?: UnifiedCareerAcademyPageContentFieldsFragment | null;
};

// Takes a slug for the 'Unified Career Academy - Page Content' type in contentful.
const withUnifiedCareerAcademyContentfulData = () =>
  compose(
    connectToRouter(({ location }) => {
      const previewParam = location.query.preview;
      const isPreview = Number(previewParam) === 1;

      return {
        isPreview,
      };
    }),
    graphql<
      { contentfulSlug: string; isPreview: boolean },
      UnifiedCareerAcademyPageContentQuery,
      UnifiedCareerAcademyPageContentQueryVariables,
      PropsFromContentful
    >(unifiedCareerAcademyPageContentQuery, {
      options: ({ isPreview, contentfulSlug }) => ({
        variables: {
          slug: contentfulSlug,
          locale: getCmsLocaleString(),
          preview: isPreview,
        },
        // Only send a request through the Preview API if the user can preview
        context: { clientName: isPreview ? 'contentfulPreviewGql' : 'contentfulGql' },
      }),
      props: ({ data }) => {
        return {
          pageContent: data?.unifiedCareerAcademyPageContentCollection?.items?.[0],
        };
      },
    })
  );

export default withUnifiedCareerAcademyContentfulData;
